import { DELETE_COMMENT } from '../../../constants/interactions';
import { COMMENT_DELETE } from '../../messages/message-types';
import { deleteComment } from '../../../actions/delete-comment';

export const deleteCommentModalResolver = (payload, { showMessage }) => (
  dispatch,
  getState,
  { fedopsLogger },
) => {
  fedopsLogger.interactionStarted(DELETE_COMMENT);
  return dispatch(deleteComment(payload)).then(() => showMessage(COMMENT_DELETE));
};
